var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D1D1D1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1680,
    height: 3230,
    transform: "translate(-472 -746)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10.5,
    r: 8.25,
    stroke: "#DCDEE3",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.99961,
    cy: 6.9,
    r: 0.9,
    fill: "#DCDEE3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.09961,
    y: 9,
    width: 1.8,
    height: 6,
    fill: "#DCDEE3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1680,
    height: 3230,
    fill: "white",
    transform: "translate(-472 -746)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoInfo);
export default __webpack_public_path__ + "static/media/ico_info.75d7de5d78edce984c6024e811668c8b.svg";
export { ForwardRef as ReactComponent };